import ProductDetail from './productDetail';
export default ProductDetail;
